var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKCare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 698.24 622.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{stroke:#000;stroke-linecap:round;stroke-linejoin:round;}.cls-2{fill:#243256;}.cls-3{fill:#54aae4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "K-care_Kardinal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "87.85 414.4 65.03 401.22 291.62 270.4 568.57 430.3 341.97 561.12 193.82 475.8 87.85 414.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "445.97 621.81 445.97 534.6 672.56 403.77 697.74 447.38 697.74 476.45 445.97 621.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.48,294a21.36,21.36,0,0,1-5.09-2.17l-34.45-19.84c-.7-.39-1.38-.83-2.06-1.3a8.75,8.75,0,0,1-.78-.58,32.06,32.06,0,0,1-2.9-2.4l17.36-10c11.12-6.39,20.24-1.12,20.24,11.72v10.68C323.8,287.5,326.8,292.37,331.48,294Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.24,393.71c-9,5.17-9,13.64,0,18.82l41.86,24.16c9,5.19,23.65,5.17,32.61,0L132,412.73c9-5.2,9-13.7,0-18.88l-41.58-24c-9-5.18-23.66-5.19-32.64,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.24,393.71c-9,5.17-9,13.64,0,18.82l41.86,24.16c9,5.19,23.65,5.17,32.61,0L132,412.73c9-5.2,9-13.7,0-18.88l-41.58-24c-9-5.18-23.66-5.19-32.64,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M398,193.74c-1.66-9.61-9.57-13.2-19.11-8.1,8.77-5.48,9.92-13.64,3.46-19.8C390.33,172.44,396.59,183.58,398,193.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.64,423.08v.54c0,12.83-9.09,18.09-20.21,11.69L21,415.48c-.7-.4-1.38-.84-2.05-1.31a7.64,7.64,0,0,1-.79-.58C8.34,406.36.75,392.22.75,380.49V341.13c0-12.84,9.1-18.08,20.21-11.66l34.45,19.9a38,38,0,0,1,11,10.18,48.85,48.85,0,0,1,5,8.32,41.41,41.41,0,0,1,4,13c0,8.8.07,21.68.14,31.94l.06,9.2C75.62,422.39,75.63,422.74,75.64,423.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M378.87,185.64c-.25.12-.51.26-.77.41l-36.41,21-8,4.61-4.2,2.43-56.29,32.5L131.87,328.22s0,0,0,0l-36.21,20.9c-.73.41-1.44.86-2.14,1.31-7.07,4.62-13.07,11.22-16,17.3a17.38,17.38,0,0,0-2,7.39c0,1.59,0,3.54,0,5.75a41.41,41.41,0,0,0-4-13,48.85,48.85,0,0,0-5-8.32,38,38,0,0,0-11-10.18L21,329.47C9.85,323.05.75,328.29.75,341.13V380c0-.35,0-.69,0-1L.65,369.7C.57,356.88.5,339.92.5,332s9.1-19.6,20.22-26L303.19,142.93a21.72,21.72,0,0,1,3.43-1.64l.11,0c11.16-4.7,27-4.13,37.1,1.68l34.27,19.78a21.6,21.6,0,0,1,4.23,3.13C388.79,172,387.64,180.16,378.87,185.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M398.31,237.08c0,.62,0,1.24-.07,1.82-.78,12.46-9.54,27.09-20.14,33.2L344,291.78a21.42,21.42,0,0,1-5.7,2.34l-.17,0a15.3,15.3,0,0,1-2,.31l-.72,0s0,0,0,0a15.14,15.14,0,0,1-3.83-.53l0,0c-4.68-1.58-7.68-6.45-7.68-13.84V269.43c0-12.84-9.12-18.11-20.24-11.72l-17.36,10-116.66,67c-11.13,6.38-20.25,22.12-20.25,35v10c0,9.35-4.83,20.26-11.75,28h0a34.89,34.89,0,0,1-8.44,7L96,433.71c-10.82,6.25-19.78,1.44-20.35-10.63v-38.7a29.52,29.52,0,0,0-.21-3.48c0-2.21,0-4.16,0-5.75a17.38,17.38,0,0,1,2-7.39c3-6.08,9-12.68,16-17.3a26.67,26.67,0,0,0,2.44-1.26l34-19.7c.7-.4,1.34-.82,2-1.25,0,0,0,0,0,0L273.2,246.61l56.29-32.5,4.2-2.43,8-4.61a24.17,24.17,0,0,0,2.48-1.28l33.95-19.7c.25-.15.5-.29.75-.45,9.54-5.1,17.45-1.51,19.11,8.1,0,.15,0,.29.07.42a30.94,30.94,0,0,1,.23,3.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "169.02 461.92 169.02 258.41 445.97 418.31 445.97 621.81 169.02 461.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "345.89 359.8 345.89 330.67 521.5 229.34 520.66 256.92 345.89 359.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "445.97 534.6 345.89 359.8 520.66 256.92 672.56 403.77 445.97 534.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "169.02 229.34 345.26 127.59 521.5 229.34 345.89 330.67 169.02 229.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "453.04 515.98 653.28 400.37 521.49 272.95 365.28 363.14 452.78 515.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "169.02 229.34 169.02 258.41 345.89 359.8 345.89 330.67 169.02 229.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M511.11,196.2a27,27,0,0,1-6.39-2.72l-43.26-24.92c-.88-.5-1.74-1.05-2.59-1.63a11.86,11.86,0,0,1-1-.73,42.19,42.19,0,0,1-3.64-3L476,150.68c14-8,25.42-1.39,25.42,14.73v13.41C501.46,188.1,505.23,194.22,511.11,196.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.26,321.46C104,328,104,338.59,115.25,345.1l52.56,30.34c11.27,6.51,29.7,6.49,40.95,0l51.8-30.06c11.26-6.53,11.25-17.19,0-23.7l-52.2-30.14c-11.27-6.5-29.72-6.51-41,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.26,321.46C104,328,104,338.59,115.25,345.1l52.56,30.34c11.27,6.51,29.7,6.49,40.95,0l51.8-30.06c11.26-6.53,11.25-17.19,0-23.7l-52.2-30.14c-11.27-6.5-29.72-6.51-41,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M594.61,70.36c-2.09-12.07-12-16.57-24-10.17,11-6.88,12.46-17.12,4.34-24.86C585,43.62,592.87,57.6,594.61,70.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M189.85,358.35V359c0,16.12-11.41,22.72-25.38,14.69L121.22,348.8c-.88-.5-1.74-1.06-2.59-1.64a11.86,11.86,0,0,1-1-.73c-12.31-9.08-21.85-26.84-21.85-41.56V255.44c0-16.12,11.43-22.71,25.38-14.64l43.26,25a48,48,0,0,1,13.86,12.8A61.17,61.17,0,0,1,184.61,289a52.23,52.23,0,0,1,5,16.36c0,11.06.08,27.23.17,40.11l.07,11.55C189.82,357.49,189.83,357.92,189.85,358.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "322.56 317.01 322.56 258.87 304.49 248.86 272.19 288.33 322.56 317.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M570.61,60.19c-.31.15-.64.33-1,.52L523.92,87.1l-10,5.79L508.61,96l-70.68,40.8L260.45,239.23s0,0-.05,0l-45.46,26.24c-.92.51-1.81,1.08-2.69,1.65-8.88,5.8-16.42,14.09-20.16,21.73a21.74,21.74,0,0,0-2.53,9.27c0,2,0,4.45,0,7.22a52.23,52.23,0,0,0-5-16.36,61.17,61.17,0,0,0-6.31-10.44,48,48,0,0,0-13.86-12.8l-43.26-25c-14-8.07-25.38-1.48-25.38,14.64v48.75c0-.43,0-.86,0-1.31l-.09-11.56c-.1-16.11-.19-37.4-.19-47.31s11.43-24.6,25.4-32.66L475.58,6.55a28.87,28.87,0,0,1,4.31-2l.14,0c14-5.9,33.94-5.19,46.58,2.1l43,24.85A26.43,26.43,0,0,1,575,35.33C583.07,43.07,581.63,53.31,570.61,60.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "653.28 400.37 521.49 272.95 521.49 276.75 650.83 401.78 653.28 400.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M595,124.79c0,.78,0,1.55-.08,2.28-1,15.65-12,34-25.3,41.68l-42.8,24.73a26.88,26.88,0,0,1-7.16,2.93l-.21.05a20.35,20.35,0,0,1-2.57.4l-.89,0a0,0,0,0,1,0,0,18.67,18.67,0,0,1-4.81-.67l-.05,0c-5.88-2-9.65-8.1-9.65-17.38V165.41c0-16.12-11.45-22.74-25.42-14.73l-21.79,12.5L307.76,247.3c-14,8-25.43,27.78-25.43,43.9v12.53c0,11.74-6.07,25.45-14.76,35.14h0a43.65,43.65,0,0,1-10.6,8.81l-41.55,24c-13.58,7.85-24.84,1.81-25.55-13.34l0-48.6a38.43,38.43,0,0,0-.25-4.37c0-2.77,0-5.22,0-7.22a21.74,21.74,0,0,1,2.53-9.27c3.74-7.64,11.28-15.93,20.16-21.73a34.09,34.09,0,0,0,3.07-1.58L258,240.84c.88-.5,1.69-1,2.45-1.57,0,0,0,0,.05,0L437.93,136.75,508.61,96l5.28-3.06,10-5.79A31.53,31.53,0,0,0,527,85.5l42.64-24.74c.31-.19.62-.36.93-.57,12-6.4,21.91-1.9,24,10.17a5.42,5.42,0,0,1,.08.54,38.24,38.24,0,0,1,.3,4.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "521.49 272.95 521.49 276.75 367 366.15 365.28 363.14 521.49 272.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "524 331.1 499.57 345.01 477.62 323.78 502.04 309.86 524 331.09 524 331.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "524 331.1 524 336.11 499.57 350.04 477.62 328.81 477.62 323.78 499.57 345.01 524 331.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "519.14 321.89 499.83 332.89 482.47 316.11 501.78 305.1 519.14 321.88 519.14 321.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "519.14 321.89 519.14 329.82 499.83 340.83 482.47 324.05 482.47 316.11 499.83 332.89 519.14 321.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "489.66 352.19 465.24 366.11 443.28 344.88 467.7 330.96 489.66 352.19 489.66 352.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "489.66 352.19 489.66 357.21 465.24 371.13 443.28 349.91 443.28 344.88 465.24 366.11 489.66 352.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "484.8 342.99 465.49 353.99 448.13 337.2 467.44 326.2 484.8 342.98 484.8 342.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "484.8 342.99 484.8 350.92 465.49 361.93 448.13 345.15 448.13 337.2 465.49 353.99 484.8 342.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "453.73 373.76 429.31 387.68 407.35 366.45 431.77 352.52 453.73 373.75 453.73 373.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "453.73 373.76 453.73 378.77 429.31 392.7 407.35 371.47 407.35 366.45 429.31 387.68 453.73 373.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "448.87 364.55 429.56 375.55 412.21 358.77 431.51 347.76 448.87 364.55 448.87 364.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "448.87 364.55 448.87 372.49 429.56 383.5 412.21 366.71 412.21 358.77 429.56 375.55 448.87 364.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "562.11 367.02 537.69 380.94 515.73 359.71 540.15 345.78 562.11 367.01 562.11 367.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "562.11 367.02 562.11 372.04 537.69 385.96 515.73 364.73 515.73 359.71 537.69 380.94 562.11 367.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "557.25 357.81 537.95 368.81 520.59 352.03 539.89 341.02 557.25 357.8 557.25 357.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "557.25 357.81 557.25 365.75 537.95 376.76 520.59 359.98 520.59 352.03 537.95 368.81 557.25 357.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "527.77 388.12 503.35 402.03 481.39 380.81 505.81 366.88 527.77 388.11 527.77 388.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "527.77 388.12 527.77 393.13 503.35 407.06 481.39 385.83 481.39 380.81 503.35 402.03 527.77 388.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "522.91 378.91 503.61 389.91 486.25 373.13 505.56 362.12 522.91 378.9 522.91 378.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "522.91 378.91 522.91 386.85 503.61 397.85 486.25 381.07 486.25 373.13 503.61 389.91 522.91 378.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "491.84 409.68 467.42 423.6 445.46 402.37 469.89 388.45 491.84 409.68 491.84 409.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "491.84 409.68 491.84 414.7 467.42 428.62 445.46 407.4 445.46 402.37 467.42 423.6 491.84 409.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "486.99 400.48 467.68 411.48 450.32 394.69 469.63 383.69 486.99 400.47 486.99 400.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "486.99 400.48 486.99 408.41 467.68 419.42 450.32 402.64 450.32 394.69 467.68 411.48 486.99 400.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "600.74 404.15 576.32 418.07 554.36 396.84 578.78 382.92 600.74 404.14 600.74 404.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "600.74 404.15 600.74 409.17 576.32 423.09 554.36 401.87 554.36 396.84 576.32 418.07 600.74 404.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "595.88 394.94 576.58 405.95 559.22 389.17 578.52 378.16 595.88 394.94 595.88 394.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "595.88 394.94 595.88 402.88 576.58 413.89 559.22 397.11 559.22 389.17 576.58 405.95 595.88 394.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "566.4 425.25 541.98 439.17 520.02 417.94 544.45 404.02 566.4 425.24 566.4 425.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "566.4 425.25 566.4 430.27 541.98 444.19 520.02 422.96 520.02 417.94 541.98 439.17 566.4 425.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "561.54 416.04 542.24 427.04 524.88 410.26 544.19 399.26 561.54 416.04 561.54 416.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "561.54 416.04 561.54 423.98 542.24 434.99 524.88 418.21 524.88 410.26 542.24 427.04 561.54 416.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "530.47 446.82 506.05 460.73 484.1 439.51 508.52 425.58 530.47 446.81 530.47 446.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "530.47 446.82 530.47 451.83 506.05 465.76 484.1 444.53 484.1 439.51 506.05 460.73 530.47 446.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "525.62 437.61 506.31 448.61 488.95 431.83 508.26 420.82 525.62 437.6 525.62 437.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "525.62 437.61 525.62 445.55 506.31 456.55 488.95 439.77 488.95 431.83 506.31 448.61 525.62 437.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "322.56 317.01 322.56 258.87 347.74 244.33 347.74 302.48 322.56 317.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "347.74 244.33 329.67 234.33 304.49 248.86 322.56 258.87 347.74 244.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "472.71 230.37 472.71 172.22 497.88 157.69 497.88 215.83 472.71 230.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "497.88 157.69 479.81 147.68 454.63 162.22 472.71 172.22 497.88 157.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "472.71 230.37 472.71 172.22 454.63 162.22 422.34 201.69 472.71 230.37"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKCare);
export default __webpack_public_path__ + "static/media/K-Care.4f7e421fb1d56823dd4a903d455cba0d.svg";
export { ForwardRef as ReactComponent };